module.exports = __webpack_public_path__ + "static/media/u23a-c_1.d07bd75a.mp3";